// extracted by mini-css-extract-plugin
export default {"sidebar":"O2iLXwUoYZxV1l-IzrqRyw==","content":"FmK+FlIpdgvl3WaLy6kRlA==","header":"RMeKm40nRjmovSKhV-+-ig==","main":"lluuLUR00LPlv9thdDQqKA==","footer":"i3p+G93ETCEWFr5Oe5xXNA=="};